import {
  FINALIST_ANNOUNCEMENT_OPEN,
  INTERVIEW_ANNOUNCEMENT_OPEN,
  REGISTRATION_OPEN,
} from './const'

export const eligibleStepsForFinalistPage = [
  'interview_candidate',
  'interviewed',
  'finalist',
  'reserved',
  'finalist_confirmed',
]

const getRedirectPath = (status: string, step: string): string => {
  const shouldNavigateToFinalistPage = eligibleStepsForFinalistPage.includes(
    step
  )

  if (FINALIST_ANNOUNCEMENT_OPEN && shouldNavigateToFinalistPage) {
    return '/announcement/finalist'
  }

  if (INTERVIEW_ANNOUNCEMENT_OPEN) {
    return '/announcement/interview'
  }

  if (REGISTRATION_OPEN) {
    if (status === 'completed') {
      return '/step/submitted'
    }
    return `/step/${step}`
  }
  return '/'
}

export { getRedirectPath }
